export default __webpack_public_path__ + "static/media/pinball-machines.18e4f0eb.png";